import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {  Row } from 'reactstrap';

const LabsModal = ({ data, openModal, setOpenModal, addDiagnostic }) => {

    const selectedProcedures = [];     

    const handleChange = (event) => {

        let procedure = JSON.parse(event.target.value)
        if(event.target.checked){            
            selectedProcedures.push(procedure);
        }else{           
            selectedProcedures.splice(selectedProcedures.indexOf(procedure),1)         
        }
        
    }

    const sendProcedures = () =>{
       
        selectedProcedures.forEach(element =>{
            addDiagnostic(element);
        })

        setOpenModal();       
    }

    return (
        <Modal
            open={openModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}>

            <div className="paperAppointment-flex" style={{ width: '70%', margin: 10 }}>
                <div className="card__title">
                    <h4 className="bold-text">Exámenes de Laboratorio </h4>
                </div>
                <Row>
                    {data.map((procedures, index) => {
                        return <div key={index} style={{ width: 280, border: '1px solid #B2B8BF' }}>
                            <FormControlLabel
                                style={{ margin: 5 }}
                                control={<Checkbox  onChange={handleChange} />}
                                value={JSON.stringify(procedures)}
                                label={procedures.abreviatura}
                            />
                        </div>
                    })}
                </Row>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                        style={{ marginTop: 10 }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            sendProcedures();
                        }}
                    >
                        Aceptar
                    </Button>
                    <Button
                        style={{ marginTop: 10, marginLeft: 10 }}
                        variant="contained"                        
                        onClick={() => {
                            setOpenModal();
                        }}
                    >
                        Cerrar
                    </Button>
                </div>
            </div>
        </Modal>
    );

}

export default LabsModal;